import { z } from "zod";
const idSchema = z.string().trim().min(1).max(160);
export const twinRunEvaluationEvidenceRefSchema = z.object({
    eventId: idSchema,
    toolCallId: idSchema,
    toolName: z.string().trim().min(1).max(240),
    queriedRelations: z.array(z.string().trim().regex(/^[A-Za-z_][A-Za-z0-9_]*\.[A-Za-z_][A-Za-z0-9_]*$/u)).max(100),
    rowCount: z.number().int().nonnegative().optional(),
    certificateId: idSchema.optional(),
    certificateSha256: z.string().regex(/^[a-f0-9]{64}$/u).optional(),
    sessionContractCoverageItemIds: z.array(idSchema).max(16).optional(),
    sessionContractCoverageKeys: z.array(z.string().trim().regex(/^[a-z][a-z0-9_]*(?:\.[a-z][a-z0-9_]*)+$/u)).max(16).optional(),
}).strict();
